import { NgClass } from '@angular/common';
import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { NgbToastModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { Toast, ToastService, ToastType } from './toast.service';

@Component({
  selector: 'app-toast-container',
  imports: [NgbToastModule, NgClass],
  templateUrl: './toast-container.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './toast-container.component.scss',
})
export class ToastContainerComponent {
  protected readonly toastService = inject(ToastService);
  protected readonly translateService = inject(TranslateService);
  protected readonly ToastType = ToastType;

  protected copyAndClose(toast: Toast) {
    this.toastService.remove(toast);

    if (toast.type === ToastType.Danger) {
      navigator.clipboard.writeText(
        `[Toast Error] ${toast.title} - ${toast.message}`
      );
      this.toastService.info(
        this.translateService.instant('toastr.copiedToClipboardMessage'),
        this.translateService.instant('toastr.copiedToClipboardTitle'),
        2000
      );
    }
  }

  protected remove(toast: Toast) {
    this.toastService.remove(toast);
  }
}
